<!--
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-13 14:59:29
 * @LastEditors: chen wei
 * @LastEditTime: 2020-07-22 19:57:08
 -->
<template>
  <div class="closeBox">
    <van-popup :value="show"
      @click-overlay="emitClose"
      class="noBg">
      <div class="closeConBox">
        <div class="title">提示</div>
        <div class="msg">恭喜您完成全部模块的学习！</div>
        <div class="btns">
          <van-button round
            class="btn"
            type="primary"
            @click="close">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getArgs } from '@/assets/js/common'
export default {
  name: 'OralExpressionClose',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.props == 'close') {
      this.msg = '您确定要离开当前学习吗？'
    } else {
      this.msg = '太棒了！恭喜您完成该模块的学习，再接再厉哦！'
    }
  },
  data() {
    return {}
  },
  methods: {
    emitClose() {
      this.$emit('close')
    },
    close() {
      const book_id = getArgs().book_id
      // jumpWebView.getReturn()
      location.replace('./index.html?showDetail=true&book_id=' + book_id)
    }
  }
}
</script>
<style lang="less" scoped>
.closeBox {
  .noBg {
    background: transparent;
    .closeConBox {
      background: #fff;
      border-radius: 5px;
      padding: 20px;
      box-sizing: border-box;
      width: 294px;
      .title {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: rgba(69, 70, 74, 1);
        line-height: 16px;
        margin-bottom: 20px;
      }
      .msg {
        font-size: 14px;
        font-weight: 400;
        color: rgba(116, 118, 125, 1);
        line-height: 21px;
        margin-bottom: 22px;
        text-align: center;
      }
      .btns {
        display: flex;
        justify-content: center;
        .btn {
          width: 120px;
          height: 40px;
          line-height: 38px;
          background: #45d585;
          border-color: #45d585;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}
</style>
